import { render, staticRenderFns } from "./VantDiscussReportPop.vue?vue&type=template&id=89fc5cba&"
import script from "./VantDiscussReportPop.vue?vue&type=script&lang=js&"
export * from "./VantDiscussReportPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports